import React from 'react';
import { useStoreState } from 'base/store';
import ListProductImage from '../ListProductImage';
import ListProductName from '../ListProductName';
import ProductPrice from '@base/snippets/ProductPriceV2';
import ListProductRate from '../ListProductRate';
import ListProductPoints from '@base/snippets/ListProduct/ListProductPoints';
import ListProductFlashsaleProgress from '@base/snippets/ListProduct/ListProductFlashsaleProgress';
import { ListProductProps, ELEMENT_LIST } from '@base/snippets/ListProduct';
import ListProductAddToCartBtn from '@base/snippets/ListProduct/ListProductAddBtn';

const ListProductShowDefault = React.forwardRef<HTMLDivElement, ListProductProps>((props, ref) => {
    const {
        moduleElementId,
        addCart,
        aTarget,
        className,
        style,
        product,
        elements = ELEMENT_LIST,
        imageSize,
        spaceAroundPicture,
        spaceBelowPicture,
        imgExtra,
        showTag,
        isHoverChangeAsset,
        offTagShow,
        productTag,
        onQuickView,
        onClickProd,
        priceDirection,
        rateType = 'simple',
        children,
        listConfig,
        'data-t-tar': dataTrackTarget,
        'data-t-pos': dataTrackPosition,
        'data-t-vid': dataTrackVariantId,
        'data-t-price': dataTrackVariantPrice,
    } = props;

    const { ua: { isMobile } } = useStoreState('rootStore')

    return (
        <div
            className={className}
            style={style}
            ref={ref}
            data-t-tar={dataTrackTarget}
            data-t-pos={dataTrackPosition}
            data-t-vid={dataTrackVariantId}
            data-t-price={dataTrackVariantPrice}
        >
            <ListProductImage
                moduleElementId={moduleElementId}
                aTarget={aTarget}
                product={product}
                imageSize={imageSize}
                spaceAround={spaceAroundPicture}
                spaceBelow={spaceBelowPicture}
                showTag={showTag}
                isHoverChangeAsset={isHoverChangeAsset}
                offTagShow={offTagShow}
                productTag={productTag}
                imgExtra={imgExtra}
                onQuickView={isMobile ? void 0 : onQuickView}
                onClick={onClickProd}
            />
            {children || (
                <div className="info">
                    {elements.includes('name') && <ListProductName aTarget={aTarget} product={product} onClick={onClickProd}/>}

                    {elements.includes('rate') && <ListProductRate product={product} type={rateType}/>}

                    <div className='flex flex-justify flex-middle price-rate-wrap'>
                        {(elements.includes('price')) &&
                            <ProductPrice
                                product={product}
                                showDelPrice={elements.includes('underlinedPrice')}
                                direction={priceDirection}
                            />}

                        {/* 提交按钮 */}
                        {(elements.includes('addCart')) &&
                            <ListProductAddToCartBtn addCart={addCart} product={product}/>
                        }
                    </div>

                    {/* flashsale 进度条 */}
                    {elements.includes('flashsale') && (
                        <ListProductFlashsaleProgress
                            product={product}
                            listConfig={listConfig}
                        />
                    )}

                    {elements.includes('points') && <ListProductPoints product={product}/>}

                </div>
            )}
        </div>
    )
});

export default ListProductShowDefault;